import PropTypes from 'prop-types';
import React from 'react';
import { NavLink, generatePath } from 'react-router-dom';
import { useConfig } from 'app/hooks';
import styled from 'styled-components';

const propTypes = {
  item: PropTypes.object.isRequired,
};

const GiftCardMenuDymanic = ({
  item,
  keyData,
}) => {
  const { routes } = useConfig();

  const newDate = new Date()

  const date = newDate.getDate();
  // eslint-disable-next-line no-unused-vars
  const month = newDate.getMonth() + 1;
  // eslint-disable-next-line no-unused-vars
  const year = newDate.getFullYear();

  const Link = styled.div`
  ul a {
    color:#DE1619;
    text-decoration: underline;
  }
  `
  return (
    <Link>
      <h2> {item?.item?.name}</h2>
      <ul key={keyData}>
        {/* {item?.list?.length > 0 ?
          item?.list?.map((data) => (
            <li>{data}</li>
          ))
          : <li>-</li>
        } */}
        {item?.data_array?.length > 0 ?
          item?.data_array?.map((data) => (
            <>
              < NavLink
                to={{
                  pathname: generatePath(routes.cinemaDetails.pattern, {
                    id: data?.cinemaUrlName.replaceAll(' ', '-')
                  }),
                  search: `?date=${date}`,
                  state: { cinemaId: data.id }
                }}
                className="l-cinemas__link"
              >
                {data?.name}
              </NavLink>
            </>
            // <li>{data?.name}</li>
          ))
          : <li>-</li>
        }
      </ul>
    </Link>
  );
};

GiftCardMenuDymanic.propTypes = propTypes;
// GiftCardMenuDymanic.defaultProps = defaultProps;
export default GiftCardMenuDymanic;
